import React, { useContext } from "react";
import styled from "styled-components";
import { Button, FlexContainer } from "src/components";
import DigitalCompanyCardContext from "src/scenes/DigitalMemberCard/DigitalCompanyCardContext";
import EmployeeAppleCard from "./EmployeeAppleCard";
import EmployeeGoogleCard from "./EmployeeGoogleCard";
import pluralize from "pluralize";
import { customNames, capitalizeString } from "src/utils/helpers";

const H2 = styled.h2`
    color: #171A22;
    font-size: 1.563rem;
    font-weight: 800;
    margin: 0;
    flex-grow: 1;
`;

const CardDescription = styled.div`
    color: #6A7387;
    font-size: 0.875rem;
    max-width: 400px;
    flex-grow: 1;
    font-weight: 500;
    line-height: 1.5;
`;

const H3 = styled.h3`
    color: #171A22;
    font-size: 0.875rem;
    font-weight: 800;
    margin-bottom: 0.75rem;
`;

const CardSpacer = styled.div`
    flex-grow: 1;
    margin-top: 2rem;
    min-height: 450px;
`;

const Divider = styled.div`
    border-right: 1px solid #D8DEEC;

    @media (max-width: 980px) {
        border-right: none;
        border-bottom: 1px solid #D8DEEC;
        width: 100%;
    }
`;

const PreviewSurface = styled(FlexContainer)`
    background: #FFFFFF;
    border: 1px solid #D8DEEC;
    border-radius: 16px;
    box-shadow: 0 18px 36px rgba(29, 42, 89, 0.08);
    margin: 1rem 0;
    min-width: 0;
    transition: transform 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease;

    &:hover {
        border-color: #C9D2E7;
        box-shadow: 0 14px 28px rgba(29, 42, 89, 0.09);
        transform: translateY(-1px);
    }
`;

const DisplayCompanyCards = () => {
    const { 
        renderCustomiseEmployee,
        renderCustomiseClient
    } = useContext(DigitalCompanyCardContext);

    return (
        <>
            <FlexContainer flexGrow="1" mDirection="column" tDirection="column" direction="row" width="100%" justifyContent="space-evenly" gap="1rem">
                
                <PreviewSurface padding="2rem" style={{ alignItems: "center", textAlign: "center" }}>
                    <H2>{capitalizeString(pluralize.singular(customNames.employees))} Card Preview</H2>
                    <CardDescription>View and manage your custom digital {pluralize.singular(customNames.employees.toLowerCase())} cards, featuring personalised IDs and company branding.</CardDescription>
                    <CardSpacer>
                        <FlexContainer alignItems="flex-start" mDirection="column" tDirection="column" direction="row" width="100%" justifyContent="space-evenly" gap="10px">
                            <div>
                                <H3>Apple Wallet</H3>
                                <EmployeeAppleCard isTemplateForClientPreview={false} />
                            </div>
                            <div>
                                <H3>Google Wallet</H3>
                                <EmployeeGoogleCard isTemplateForClientPreview={false} />
                            </div>
                        </FlexContainer>
                    </CardSpacer>

                    <div><CustomizeButton onClick={ renderCustomiseEmployee } /></div>
                </PreviewSurface>
                
                <Divider />

                <PreviewSurface padding="2rem" style={{ alignItems: "center", textAlign: "center" }}>
                    <H2>{capitalizeString(pluralize.singular(customNames.clients))} Card Preview</H2>
                    <CardDescription>Review and customise your {pluralize.singular(customNames.clients.toLowerCase())} digital cards, displaying unique IDs with your company logo and colours.</CardDescription>
                    <CardSpacer>
                        <FlexContainer alignItems="flex-start" mDirection="column" tDirection="column" direction="row" width="100%" justifyContent="space-evenly" gap="10px">
                            <div>
                                <H3>Apple Wallet</H3>
                                <EmployeeAppleCard isTemplateForClientPreview={true} />
                            </div>
                            <div>
                                <H3>Google Wallet</H3>
                                <EmployeeGoogleCard isTemplateForClientPreview={true} />
                            </div>
                        </FlexContainer>
                    </CardSpacer>

                    <div><CustomizeButton onClick={ renderCustomiseClient } /></div>
                </PreviewSurface>
            </FlexContainer>
        </>
    );
}; 

const BlackButton = styled(Button)`
    background: #000000 0% 0% no-repeat padding-box;
    padding: 10px 38px 10px 38px !important;
    border-radius: 8px !important;
    color: #fff;
    font-size: 0.875rem;
    font-weight: 700;
    text-align: center;
    margin-top: 2em;
`;

const CustomizeButton = ({ onClick }) => {
    return (
        <BlackButton onClick={() => onClick()} >
            Customise
        </BlackButton>
    );
};

export default DisplayCompanyCards;
